<template>
  <app-status class="user__status" :online="this.isOnline" />
</template>

<script>
import AppStatus from "@/components/ui/status/AppStatus";

export default {
  components: { AppStatus },
  data: () => ({
    isOnline: true
  })
};
</script>

<style lang="scss">
.user__status.status {
  margin: 0 12px;

  @include breakpoint("sm-and-down") {
    margin: 0 8px;
  }
}
</style>
